import React from "react";

import { ThemeProvider } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import theme from "themes";

import { AdminDashboard } from "features/AdminDashboard";
import { MasterDashboard } from "features/MasterDashboard";

import { PageHeader } from "components/PageHeader";

export const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const customization = useSelector((state: any) => state.customization);
  const { profileName } = useSelector((state: any) => state.profile);

  return profileName === "Master" ? (
    <>
      <PageHeader label={t("dashboard.title")} background="secondary" />
      <MasterDashboard />
    </>
  ) : (
    <ThemeProvider theme={theme(customization)}>
      <AdminDashboard isFull />
    </ThemeProvider>
  );
};
